<script>
  import {
    GL,
    Card,
    Button,
    Callout,
    Flex,
    FlexItem,
    TextField,
  } from "@gl/design-system";
  import { getContext } from "svelte";
  import { resolveIDP } from "../../services/IDP";
  import { isEmail } from "../../utils/validators";
  import { _ } from "../../stores/index";

  const config = getContext("config");

  let email = "";
  let error = "";
  let loading = false;

  async function login() {
    email = email.trim();
    if (!email) {
      error = $_("validation.email.required");
      return;
    }
    const [valid] = isEmail(email);
    if (!valid) {
      error = $_("validation.email.invalid");
      return;
    }
    loading = true;
    error = "";
    const resetTimer = setTimeout(() => {
      loading = false;
    }, 5000);
    try {
      const returnTo = new URLSearchParams(window.location.search).get(
        "returnTo",
      );
      const idp = await resolveIDP(email);
      await idp.login(returnTo, email);
    } catch (e) {
      error = e.message ?? e.statusText ?? "Login failed";
    } finally {
      clearTimeout(resetTimer);
      loading = false;
    }
  }

  function returnToURL() {
    if (
      !window.location.search.includes("returnTo") &&
      window.location.pathname !== "/"
    ) {
      const currentPath = window.location.pathname + window.location.hash;
      window.history.replaceState(
        {},
        "",
        `/?returnTo=${encodeURIComponent(currentPath)}`,
      );
    }
  }

  returnToURL();
</script>

<svelte:head>
  <title>
    {config.NAME}
  </title>
</svelte:head>

<div id="login-page" class="theme-dark cubes-bg">
  <Flex class="flex-direction-column align-items-center">
    <FlexItem class="mb-2">
      <GL light />
    </FlexItem>
    <FlexItem class="mb-5">
      <h1 class="header">
        {getContext("config").NAME}
      </h1>
    </FlexItem>
    <div class="login-container">
      <div class="welcome-container">
        <p class="welcome">{$_("login.welcome")}</p>
        <p class="welcome-subtitle">{$_("login.provide_credentials")}</p>
      </div>

      <TextField
        label={$_("users.email_address")}
        placeholder=""
        bind:value={email}
        on:keydown={(e) => e.key === "Enter" && login()}
        disabled={loading}
      />

      <Button style="width:100%" on:click={login} disabled={loading || !email}
        >{$_("login.sso")}</Button
      >

      <div class="color-error my-5">
        <b>{error}</b>
      </div>
    </div>
  </Flex>
  <div class="footer ml-5">
    Copyright © G&L Geißendörfer & Leschinsky GmbH • <a
      href="https://www.gl-systemhaus.de/en/imprint"
      target="_blank">Imprint</a
    >
    •
    <a href="https://www.gl-systemhaus.de/en/privacy" target="_blank">Privacy</a
    >
    •
    <a href="https://www.gl-systemhaus.de/en/terms" target="_blank"
      >Terms of service</a
    >
  </div>
</div>

<style>
  #login-page {
    background-color: #002735;
    min-width: 100vw;
    min-height: 100vh;
  }

  .cubes-bg {
    background-color: #002735;
    background-image: url("/src/assets/cubes-bg.svg");
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 5%;
  }

  .login-container {
    background-color: #003143;
    padding: 32px 42px 0px;
    width: 500px;
  }

  .welcome-container {
    padding-bottom: 24px;
    margin-bottom: 24px;
    text-align: center;
    border-bottom: 1px solid #001f2a;
  }

  .welcome {
    font-size: 24px;
    font-weight: 700;
  }

  .footer {
    position: absolute;
    bottom: 20px;
  }
</style>
